import {Navigate} from 'react-router'
import {useAuth} from './use-auth.js'
import {ConnectionError} from '../components/connection-error/connection-error.jsx'

/**
 * Route guard. Renders children if the user satisfies the role requirement,
 * otherwise redirects to `/`.
 * @param {{admin?: boolean, children: React.ReactNode}} props
 */
export function RequireRole({admin, children}) {
    const {user, status, refresh} = useAuth()
    if (status === 'loading')
        return null
    //server unreachable — keep the session and offer a retry rather than logging out
    if (status === 'error')
        return <ConnectionError onRetry={refresh}/>
    if (status !== 'authed' || !user)
        return <Navigate to="/auth?invalid=1" replace/>
    if (admin && !user.roles?.admin)
        return <Navigate to="/" replace/>
    return children
}

/**
 * @param {{children: React.ReactNode}} props
 */
export function RequireAuth({children}) {
    const {status, refresh} = useAuth()
    if (status === 'loading')
        return null
    if (status === 'error')
        return <ConnectionError onRetry={refresh}/>
    if (status !== 'authed')
        return <Navigate to="/auth?invalid=1" replace/>
    return children
}
